import { render, staticRenderFns } from "./LoginFail.vue?vue&type=template&id=6cc29a98&"
import script from "./LoginFail.vue?vue&type=script&lang=js&"
export * from "./LoginFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports